import { Flex } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const GreySpan = styled.span<{ hasError?: boolean }>`
  color: ${({ theme: { palette }, hasError }) =>
    hasError ? palette.danger : palette.secondary};
`

export const FlexWrapper = styled(Flex)`
  background-color: #f5f5f5;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #f5f5f5;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`
